import { render, staticRenderFns } from "./help-text.vue?vue&type=template&id=0c768dc9&scoped=true&"
import script from "./help-text.vue?vue&type=script&lang=ts&"
export * from "./help-text.vue?vue&type=script&lang=ts&"
import style0 from "./help-text.vue?vue&type=style&index=0&id=0c768dc9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c768dc9",
  null
  
)

export default component.exports